import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';
import { environment as env } from '../../environments/environment';
import { Order } from './../models/order/order.model';

@Injectable({
  providedIn: 'root'
})
export class OrdersApiService {

  // cache: Order[] = [];
  orders: BehaviorSubject<Order[]> = new BehaviorSubject([]);
  orderSent: Subject<Order> = new Subject();
  orderSentError: Subject<HttpErrorResponse> = new Subject();
  $loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  loading$ = this.$loading.pipe(distinctUntilChanged(), shareReplay(1));
  lastUpdate = 0;

  constructor(private http: HttpClient) {
    this.update();
  }

  update(): BehaviorSubject<Order[]> {
    const now = Date.now();
    if (now - this.lastUpdate > 30) {
      this.lastUpdate = now;
      this.fetch();
    }
    return this.orders;
  }

  fetch(): void {
    /* TODO: GET /orders was removed from scope.
    this.http.get<Order[]>(`${env.apiPath}/orders`).subscribe(data => {
      this.cache = data;
      this.orders.next(data);
    });
    */
  }

  uuidv4(): string {
    return `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, d => {
      const c = parseInt(d, 10);
      // tslint:disable-next-line:no-bitwise
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  }

  post(order: Order): void {
    order.id = this.uuidv4();
    this.$loading.next(true);
    this.http.post<Order>(`${env.apiPath}/orders`, order)
      .toPromise()
      .then(data => {
        // assign ID to order, store it and notify listeners
        order.id = data.id;
        this.orderSent.next(data);
        this.$loading.next(false);
      }).catch(error => {
        console.error('POST /orders', error);
        this.orderSentError.next(error);
        this.$loading.next(false);
      });
  }
}
